
    <div class="voucher" >
      <ng-core-loading class="loading" *ngIf="loading"></ng-core-loading>

      <img [src]="voucher?.vouchers_provider?.logo_url" alt="Voucher">
      <b>R$ {{voucher?.amount}} para usar no {{voucher?.vouchers_provider?.name}}</b>
      <span *ngIf="!toGenerate">Válido até {{voucher?.expired_voucher  | date: "dd/MM/yy"}}</span>
      <span *ngIf="toGenerate">Válido por 2 meses</span>

      <button class="btn" *ngIf="toGenerate && !isExpired" (click)="generateVoucher()">Gerar voucher</button>
      <button class="btn outline" *ngIf="!toGenerate && !isExpired" (click)="openDetailsModal()">Ver voucher</button>
      <button class="btn outline" *ngIf="isExpired" disabled>Voucher expirado</button>
    </div>

    <voucher-details-modal #modal [voucher]="voucher"></voucher-details-modal>
  